<template>
    <CardRh :processando="processando" titulo="Espacos Fisicos" class="mb-5 mb-xl-10">
        <div class="espaco-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaEspaco" class="form-label">Pesquisar</label>
                        <input id="pesquisaEspaco" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Nome, descricao ou observacao" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="nomeEspaco" class="form-label">Nome</label>
                        <input id="nomeEspaco" v-model="nome" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Nome" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3" v-if="status">
                        <label for="statusEspaco" class="form-label">Status</label>
                        <Multiselect id="statusEspaco" @change="refreshTable" :options="statusSelect"
                            :searchable="true" v-model="statusId" />
                    </div>

                    <div class="col-12 col-lg-3 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="hasPermissao" type="button" class="btn btn-pmes-primary btn-sm"
                            data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                            Inserir
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:90px">ID</th>
                    <th>Nome</th>
                    <th>Descricao</th>
                    <th>Observacao</th>
                    <th>Status</th>
                    <th style="min-width:140px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>

        <Cadastro :service="service" @espaco-cadastrado="modeloAlterado" :modal="modal_cadastro" :perfis="perfis" />
        <Editar @espaco-alterado="modeloAlterado" :service="service" :modelo="dados" :modal="modal_atualizar" v-if="hasPermissao" :perfis="perfis" />
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import EspacoService from "@/service/v1/sigap/EspacoService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import Multiselect from '@vueform/multiselect';

@Options({
    name: "EspacoIndex",
    components: { CardRh, KDataTable, Cadastro, Editar, Multiselect },
})
export default class EspacoIndex extends IndexModelTable {
    public status: any = null;
    public statusId: any = null;
    public nome = "";
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get statusSelect() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.nome = "";
        this.statusId = null;
        this.refreshTable();
    }

    created() {
        this.service = new EspacoService();
        this.getStatus();
        this.config.order = [[1, "asc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    nome: this.nome,
                    status: this.statusId,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };

        this.modal_atualizar = 'modal_espaco_update';
        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'nome', name: 'nome' },
            { data: 'descricao', name: 'descricao' },
            { data: 'observacao', name: 'observacao' },
            { data: 'status', name: 'status' },
        ];

        this.config.columnDefs = [
            {
                targets: 4,
                render: function (row) {
                    return row?.nome ? row.nome.replaceAll('_', ' ') : '';
                }
            }
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 5,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-editar]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
    }
}
</script>

<style scoped>
.espaco-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
